export const languageSwitch = {
  floatingLabel: 'Change the language',
  arrowSwap: {
    alt: 'swap language'
  },
  flag: {
    alt: 'flag'
  }
};
